module.exports = __webpack_public_path__ + "img/tutorial_redactions_05.bee8ec57.gif";